import "../App.css";
import React from "react";
import { useState, useEffect } from "react";

import html from "../Images/html.png";
import css from "../Images/css.png";
import js from "../Images/js.png";
import rct from "../Images/react.png";
import node from "../Images/node.png";
import express from "../Images/express.png";
import nest from "../Images/nest.svg";
import typeorm from "../Images/typeorm.png";
import mongo from "../Images/mongo.png";
import sql from "../Images/sql.png";

// Sounds
import HtmlSound from "../Audio/html.aac";
import CssSound from "../Audio/css.aac";
import javascriptSound from "../Audio/javascript.aac";
import reactSound from "../Audio/reactjs.aac";

import nodeSound from "../Audio/nodejs.aac";
import expressSound from "../Audio/express.aac";
import nestSound from "../Audio/nestjs.aac";
import typeormSound from "../Audio/typeorm.aac";

import mongoSound from "../Audio/mongo.aac";
import sqlSound from "../Audio/sql.aac";

const Skills = () => {
  const [play, setPlay] = useState(false);
  const [currentSound, setCurrentSound] = useState(null);
  const [currentAudio, setCurrentAudio] = useState(null);

  useEffect(() => {
    if (currentSound == null) {
      return;
    }

    if (!play) {
      currentAudio.pause();
      currentAudio.currentTime = 0;
    } else {
      let audio = new Audio(currentSound);
      setCurrentAudio(audio);
      audio.play();
    }
  }, [play]);

  return (
    <div className="skillSet">
      <h1>Skills:</h1>
      <div className="skillCards">
        <div className="frontend">
          <h1>FrontEnd</h1>
          <ul>
            <div
              className="html"
              onMouseOver={() => {
                setCurrentSound(HtmlSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="htmlImg" src={html} />
              <li>HTML5</li>
            </div>
            <div
              className="css"
              onMouseOver={() => {
                setCurrentSound(CssSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="cssImg" src={css} />
              <li>CSS3</li>
            </div>
            <div
              className="js"
              onMouseOver={() => {
                setCurrentSound(javascriptSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="jsImg" src={js} />
              <li>JavaScript</li>
            </div>
            <div
              className="react"
              onMouseOver={() => {
                setCurrentSound(reactSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="reactImg" src={rct} />
              <li>React JS</li>
            </div>
          </ul>
        </div>
        <div className="dots1">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="backend">
          <h1>BackEnd</h1>
          <ul>
            <div
              className="node"
              onMouseOver={() => {
                setCurrentSound(nodeSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="nodeImg" src={node} />
              <li>Node Js</li>
            </div>
            <div
              className="express"
              onMouseOver={() => {
                setCurrentSound(expressSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="expressImg" src={express} />
              <li>Express JS</li>
            </div>
            <div
              className="nest"
              onMouseOver={() => {
                setCurrentSound(nestSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="nestImg" src={nest} />
              <li>Nest Js</li>
            </div>
            <div
              className="typeorm"
              onMouseOver={() => {
                setCurrentSound(typeormSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="typeormImg" src={typeorm} />
              <li>TypeOrm</li>
            </div>
          </ul>
        </div>
        <div className="dots2">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="databases">
          <h1>DataBases</h1>
          <ul>
            <div
              className="mongo"
              onMouseOver={() => {
                setCurrentSound(mongoSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="mongoImg" src={mongo} />
              <li>MongoDB</li>
            </div>
            <div
              className="sql"
              onMouseOver={() => {
                setCurrentSound(sqlSound);
                setPlay(true);
              }}
              onMouseOut={() => {
                setPlay(false);
              }}
            >
              <img className="sqlImg" src={sql} />
              <li>PostgreSQL</li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Skills;
